export const getQueryForTaskUrl = (dataSettings, diff) => {
    let query = diff ? "" : {};
    const propList = [
        "applicationId",
        "processDefinitionId",
        "perspectiveId",
        "appId",
        "id",
        "taskId",
        "guiId",
        "activityId",
        "processInstanceId",
        "processDefinitionName",
        "processInstanceName",
        "activityName",
        "subject",
        "data",
        "groups",
        "reports",
        "dashboard",
        "tasks",
        "tasksCompleted",
        "externalTaskComplete",
        "teamsTasks",
        "isManager",
        "fromAdmin",
        "readonly",
        "canUnclaim",
        "canReassign",
        "canEscalate",
        "taskExternalReports",
        "externalPhone",
        "reassignUserList",
        "taskType",
        "type",
        "isExternalTask"
    ];

    const propListToShow = {
        __reports: "reports",
        __dashboard: "dashboard",
        __tasks: "tasks",
        __tasksCompleted: "tasksCompleted",
        __externalTaskComplete: "externalTaskComplete",
        __teamsTasks: "teamsTasks",
        __isManager: "isManager",
        __fromAdmin: "fromAdmin",
        __readonly: "readonly"
    };

    propList.forEach(currentProp => {
        const currentPropData = dataSettings[currentProp];
        if (currentPropData) {
            if (currentProp === "data") {
                if (diff) {
                    query += `${query ? "&" : ""}${"applicationId"}=${currentPropData.applicationId || dataSettings.applicationId}`;
                } else {
                    query.applicationId = currentPropData.applicationId || dataSettings.applicationId;
                }
            } else if (currentProp === "groups" && currentPropData.length) {
                const [first] = currentPropData;
                if (diff) {
                    query += `${query ? "&" : ""}${"groupId"}=${first.groupId}`;
                } else {
                    query.groupId = first.groupId;
                }
            } else {
                const getCustomProp = propListToShow[currentProp];
                if (diff) {
                    query += `${query ? "&" : ""}${getCustomProp || currentProp}=${currentProp === "processInstanceName"
                        ? encodeURIComponent(currentPropData) : currentPropData}`;
                } else {
                    query[getCustomProp || currentProp] = currentPropData;
                }
            }
        }
    });
    return query;
};
